const res = await fetch('/korea-address2.json');
const rawData = await res.json();


<style src="@/assets/inquiry-form.css"></style>

<script setup>
import { onMounted, watch } from 'vue';
import { ref, computed } from 'vue'
import axios from 'axios';

const agreeTerms = ref(false);
const agreeMarketing = ref(false);
const agreeAll = ref(false);
const formSubmitted = ref(false);



const toggleAllAgreements = () => {
  agreeTerms.value = agreeAll.value;
  agreeMarketing.value = agreeAll.value;
};

// 개별 동의 변화 감지 → 전체 동의 체크 자동 조정
watch(agreeTerms, (val) => {
  if (!val) agreeAll.value = false;
  else if (val && agreeMarketing.value) agreeAll.value = true;
});

watch(agreeMarketing, (val) => {
  if (!val) agreeAll.value = false;
  else if (val && agreeTerms.value) agreeAll.value = true;
});



// 예시로 form 필드들
const addressData = ref({});            // 전체 주소 JSON 로드 결과
const sidoList = ref([]);               // 시/도 목록
const sigunguList = ref([]);            // 시군구 목록
const dongList = ref([]);
               // 읍면동 목록
const selectedSido = ref('');
const selectedSigungu = ref('');
const selectedProvince = ref('');
const selectedDistrict = ref('');
const selectedDong = ref('');

const shopName = ref('');
const inquirerPosition = ref('');

const tel1 = ref('');
const tel2 = ref('');
const tel3 = ref('');
const shopTel = computed(() => `${tel1.value}-${tel2.value}-${tel3.value}`);

const mobile1 = ref('010');
const mobile2 = ref('');
const mobile3 = ref('');
const phone = computed(() => `${mobile1.value}${mobile2.value}${mobile3.value}`);

const crm = ref('');
const email = ref('');
const message = ref('');

const barbershopId = ref('');
const inquirerName = ref('');

//const barbershopName = ref('');
//const agreePrivacy = computed(() => agreeTerms.value); // ❓ if you want to alias
//console.log('✅ agreePrivacy:', agreePrivacy.value);

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;




const isValidForm = computed(() => {

  return (
    selectedProvince.value &&
    selectedDistrict.value &&
    selectedSido.value &&
    selectedSigungu.value &&
    selectedDong.value &&
    shopTel.value &&
    shopName.value &&
    inquirerName.value &&
    inquirerPosition.value &&
    tel1.value && tel2.value && tel3.value &&
    mobile1.value && mobile2.value && mobile3.value &&
    agreeTerms.value
  );
});

function resetForm() {
  barbershopId.value = '';
  shopName.value = '';
  inquirerName.value = '';
  inquirerPosition.value = '';
  selectedSido.value = '';
  selectedSigungu.value = '';
  selectedDong.value = '';
  tel1.value = '';
  tel2.value = '';
  tel3.value = '';
  mobile1.value = '';
  mobile2.value = '';
  mobile3.value = '';
  email.value = '';
  message.value = '';
  agreeTerms.value = false;
  agreeMarketing.value = false;
}

const submitInquiry = async () => {
 
  const payload = {
    barbershopId: barbershopId.value,
    barbershopName: shopName.value,
    inquirerName: inquirerName.value,
    inquirerPosition: inquirerPosition.value,
    selectedSido: selectedSido.value,
    selectedSigungu: selectedSigungu.value,
    selectedDong: selectedDong.value,
    shopTel: shopTel.value,
    phone: phone.value,
    email: email.value,
    message: message.value,
    agreePrivacy: agreeTerms.value,
    agreeMarketing: agreeMarketing.value
 

  };



  try {
    console.log("🚀 테스트용 전송 데이터:", payload);
    
    /*
     const res = await axios.post('/api/inquiry', payload, {
                headers: {
                        'Content-Type': 'application/json'
              }
    });
    */
  const res = await axios.post(`${API_BASE_URL}/api/inquiry`, payload, {
  headers: {
    'Content-Type': 'application/json'
    }
  });

    console.log("🚀 최종 전송 데이터:============================>>>>", payload);
    console.log('✅ 접수 성공:', res.data);

    if (res.data.success) {
        window.alert('✅ 접수가 완료되었습니다. 감사합니다!');
        formSubmitted.value = true;
        resetForm(); // 입력값 초기화 함수
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

    //console.log('✅ 접수 성공: formSubmitted.value=================>>>>',  formSubmitted.value);
  } catch (err) {
    console.log('❌ 접수 실패:', err);
  }


};




// 전체 위도/경도 결과
const latitude = ref('');
const longitude = ref('');

onMounted(async () => {
  const res = await fetch('/korea-address2.json');
  const json = await res.json();
  addressData.value = json;
  sidoList.value = Object.keys(json);
});

// 시 선택 시 → 구 목록 갱신
watch(selectedSido, (newSido) => {
  if (newSido && addressData.value[newSido]?.children) {
    sigunguList.value = Object.keys(addressData.value[newSido].children);
    selectedSigungu.value = '';
    selectedDong.value = '';
    dongList.value = [];
     // ✅ 자동 지정
     selectedProvince.value = newSido;
  }
});

// 구 선택 시 → 동 목록 갱신
watch([selectedSido, selectedSigungu], ([sido, sigungu]) => {
  if (sido && sigungu && addressData.value[sido]?.children?.[sigungu]?.children) {
    dongList.value = Object.keys(addressData.value[sido].children[sigungu].children);
    selectedDong.value = '';
    
    // ✅ 자동 지정
    selectedDistrict.value = sigungu;
  }
});

// 동 선택 시 → 위도/경도 자동 할당
watch([selectedSido, selectedSigungu, selectedDong], ([sido, sigungu, dong]) => {
  console.log('🌐 선택된 주소:', sido, sigungu, dong);
  if (sido && sigungu && dong) {
    const pos = addressData.value[sido]?.children?.[sigungu]?.children?.[dong];
    if (pos) {
      latitude.value = pos.lat;
      longitude.value = pos.lng;
      console.log('📍 좌표:', latitude.value, longitude.value);
    } else {
      console.warn('⚠️ 주소 좌표를 찾을 수 없습니다:', sido, sigungu, dong);
    }
  }
});

</script>


<template>
    <div class="inquiry-wrapper">
        <div class="inquiry-header">
        <!-- 이미지 대신 텍스트 로고 -->
           <router-link to="/" class="inquiry-logo-text">마이바버샵 파트너스</router-link>
            <h2 class="inquiry-page-title">입점 문의</h2>
        </div>
    </div>
    
     <div class="inquiry-container">
          <div class="inquiry-title">* 필수입력 항목입니다.</div>
  
      <!-- 예시: 지역 선택 -->
      <div class="form-group">
      <label>시/도</label>
      <select v-model="selectedSido">
        <option disabled value="">선택하세요</option>
        <option v-for="sido in sidoList" :key="sido">{{ sido }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>시/군/구</label>
      <select v-model="selectedSigungu" :disabled="!sigunguList.length">
        <option disabled value="">선택하세요</option>
        <option v-for="sigungu in sigunguList" :key="sigungu">{{ sigungu }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>읍/면/동</label>
      <select v-model="selectedDong" :disabled="!dongList.length">
        <option disabled value="">선택하세요</option>
        <option v-for="dong in dongList" :key="dong">{{ dong }}</option>
      </select>
    </div>
    <!-- 매장 정보 -->
    <div class="form-group">
          <label>매장명 *</label>
          <input type="text" v-model="shopName" required placeholder="매장명을 입력해주세요" />
        </div>

        <div class="form-group">
          <label>문의자 이름 *</label>
          <input type="text" v-model="inquirerName" required placeholder="이름을 입력해주세요" />
        </div>

        <div class="form-group">
          <label>문의자 직급</label>
          <input type="text" v-model="inquirerPosition" placeholder="직급을 입력해주세요 (예: 대표, 디자이너, 관리자)" />
        </div>

        <div class="form-group">
          <label>매장 전화번호</label>
          <div class="tel-group">
            <input type="text" v-model="tel1" maxlength="3" placeholder="010" />
            <span>-</span>
            <input type="text" v-model="tel2" maxlength="4" />
            <span>-</span>
            <input type="text" v-model="tel3" maxlength="4" />
          </div>
        </div>

        <div class="form-group">
          <label>휴대폰 번호 *</label>
          <div class="tel-group">
            <input type="text" v-model="mobile1" maxlength="3" required placeholder="010" />
            <span>-</span>
            <input type="text" v-model="mobile2" maxlength="4" required />
            <span>-</span>
            <input type="text" v-model="mobile3" maxlength="4" required />
          </div>
        </div>




    <div class="form-group">
    <label>사용중인 고객관리 프로그램</label>
    <div class="radio-group">
        <label class="radio-option"><input type="radio" value="헤어짱/뷰티짱" v-model="crm" /> 헤어짱/뷰티짱</label>
        <label class="radio-option"><input type="radio" value="아하소프트" v-model="crm" /> 아하소프트</label>
        <label class="radio-option"><input type="radio" value="헤어인포" v-model="crm" /> 헤어인포</label>
        <label class="radio-option"><input type="radio" value="핸드SOS" v-model="crm" /> 핸드SOS</label>
        <label class="radio-option"><input type="radio" value="기타" v-model="crm" /> 기타</label>
        <label class="radio-option"><input type="radio" value="없음" v-model="crm" /> 없음</label>
    </div>
    </div>

       <!-- 약관 동의 -->
       <div class="form-group">
          <label style="font-weight: bold; font-size: 16px;">약관동의</label>
        
          <!-- 전체 동의 -->
            <div class="agreement-section">
            <label class="agreement-header">
              <input type="checkbox" v-model="agreeAll" @change="toggleAllAgreements" /> 전체 동의합니다.
            </label>
          </div>

          <div class="agreement-section">
            <div class="agreement-header">
              <label>
                <input type="checkbox" v-model="agreeTerms" /> 개인정보 수집 및 이용 동의 (필수)
              </label>
            </div>
            <div class="agreement-box">
              <p>당사는 개인정보처리방침을 통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.</p>
              <p><strong>&lt;개인정보의 수집 및 이용목적&gt;</strong></p>
              <div class="agreement-table-wrapper">
                <table>
                  <thead>
                    <tr><th>항목</th><th>목적</th><th>보유 이용기간</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>[필수] 지역, 매장명, 문의자 이름, 매장 전화번호, 휴대폰번호<br/>[선택] 문의내용, 문의자 직급, 사용중인 고객관리 프로그램 정보</td>
                      <td>파트너스 서비스 이용 상담신청</td>
                      <td>입점상담 종료 시</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>위의 항목 제공에 동의하지 않을 권리가 있습니다.<br>단, 미동의 시 마이바버샵 for 파트너스 입점상담 서비스를 받을 수 없습니다.</p>
            </div>
          </div>

          <div class="agreement-section" style="margin-top: 32px;">
            <div class="agreement-header">
              <label>
                <input type="checkbox" v-model="agreeMarketing" /> 이벤트, 마케팅 이용 및 수신 동의 (선택)
              </label>
            </div>
            <div class="agreement-box">
              <p><strong>&lt;개인정보의 수집 및 이용목적&gt;</strong></p>
              <div class="agreement-table-wrapper">
                <table>
                  <thead>
                    <tr><th>항목</th><th>목적</th><th>보유 이용기간</th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>[선택] 상호명, 문의자 이름, 전화번호, 휴대폰번호</td>
                      <td>프로모션 및 이벤트 안내<br>서비스 및 상담 관련 추가 안내</td>
                      <td>동의 철회 시까지</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>위의 목적으로 이용에 동의하지 않을 권리가 있습니다.<br>미 동의한 경우에도 마이바버샵 for 파트너스 입점상담 서비스는 받을 수 있으나 프로모션 및 이벤트 안내를 받으실 수 없습니다.</p>
            </div>
          </div>
        </div>


    <!-- 예시: 제출 버튼 
    <button class="submit-button" @click="submitInquiry" :disabled="!form.agreePrivacy">
       <button class="submit-button" :disabled="!isValidForm" @click="submitInquiry">
      -->
      <button class="submit-button" :disabled="!isValidForm"   @click="submitInquiry">
            접수하기
    </button>

      <!-- 완료 메시지 -->
      <div v-if="formSubmitted" style="margin-top: 20px; color: green; text-align: center;">
        ✅ 접수가 완료되었습니다. 감사합니다!
      </div>
    </div>
  </template>
  